import styled from 'styled-components'

export const BarrierListContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-areas: 'AS BL';
    grid-template-columns: 220px 1fr;

    .asset-selector {
        grid-area: AS;
        width: 220px;
        padding-right: 8px;
    }

    table {
        margin-left: 15px;
    }

    .no-barrier {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }
    }

    .barriers-list {
        flex-grow: 1;

        .barriers-list-header {
            display: flex;
            flex-direction: column;
            gap: 24px;
            margin: 40px 0;

            .barriers-list-asset-title {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 8px;
                color: var(--blue-800);
                font-weight: bold;
                font-size: 16px;
                padding-left: 20px;

                .asset-subtitle {
                    margin-left: 4px;
                    font-weight: normal;
                }
            }

            .barriers-list-search {
                display: flex;
                flex-direction: row;
                gap: 8px;
                padding-left: 20px;

                /* width: 370px; */
                .export-import-button {
                    padding: 6px;
                    height: 36px;
                    width: 130px;
                    /* margin-left: 10px; */
                    background: var(--gray-0);
                    border-radius: 3px;
                }
            }
        }
    }

    button {
        border-radius: 3px;

        &.no-outline-button {
            &:focus {
                outline: none;
            }
        }
    }

    .loading-spin {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }
    }

    .custom-table {
        thead {
            .custom-list-column-id {
                width: 50px;
            }

            .custom-list-column-actions {
                width: 74px;
            }
        }
    }
`
